import type { ChangeEvent, VoidFunctionComponent } from 'react';

import { FormLabel, FormLabelVariant } from '../../generic/Forms';
import type { NumberInputProps } from '../../generic/Forms/NumberInput';

import NumberInputWithUnit from './NumberInputWithUnit';

type Props = Pick<NumberInputProps, 'label' | 'value' | 'isDisabled'> & {
  unit: string;
  //  We cast to a number to avoid type issues downstream.
  onChange: (value: number, event?: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
};

/**
 * LabeledNumberInputWithUnit is an input with an extra text span for a unit
 * such as "minutes" or "days". It also includes a label above the input.
 */
const LabeledNumberInputWithUnit: VoidFunctionComponent<Props> = ({
  unit,
  label,
  value,
  isDisabled,
  onChange,
}) => (
  <FormLabel label={label} variant={FormLabelVariant.Filter}>
    <NumberInputWithUnit
      unit={unit}
      label={label}
      value={value}
      isDisabled={isDisabled}
      onChange={onChange}
    />
  </FormLabel>
);

export default LabeledNumberInputWithUnit;
